export default __webpack_public_path__ + "static/media/Introductorio-1.4e57ddde.jpg";